import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import Lottie from "lottie-react";

//import { MyUrl } from "../../../App";
import axios from "axios";
import edit from "../../Images/edit.png";
import delete77 from "../../Images/delete77.png";

export default function RTBListFirstTable({
  onSendDataForDelete,
  onSendData,
  SendDataToFirstTable,
  startDate,
  endDate,
}) {
  const [SendDataToFirstTable1, setSendDataToFirstTable] =
    useState(SendDataToFirstTable); // Set rowData to Array of Objects, one Object per Row

  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();

  const [dataToSend, setDataToSend] = useState("True");
  const [dataToSendForDelete, setdataToSendForDelete] = useState("True");

  const handleButtonClick = (
    seatId,
    id,
    sourceId,
    sourceName,
    environment,
    targeting,
    geo
  ) => {
    onSendData({
      dataToSend,
      seatId,
      id,
      sourceId,
      sourceName,
      environment,
      targeting,
      geo,
    });
  };

  const handleButtonClickForDelete = (id) => {
    onSendDataForDelete({ dataToSendForDelete, id });
  };

  //const [inputs, setInputs] = useState();
  const [vvv, setvvv] = useState(0);

  const BtnCellRenderer = (props) => {
    const updateRowData = async () => {
      console.log(props.data.campaignId);
      console.log(props.data.seatId);
      //await GetAvgQPS(props.data.campaignId, props.data.seatId);
      console.log("vvv");
      console.log(vvv);

      //console.log(await GetAvgQPS(props.data.campaignId, props.data.seatId));
      if (props.updateData) {
        props.updateData(
          props.node,
          await GetAvgQPS(props.data.campaignId, props.data.seatId)
        ); // Assuming '1' is the value you want to set
      }
    };

    return (
      <button
        onClick={updateRowData}
        style={{
          borderWidth: 0,
          borderRadius: 5,
          backgroundColor: "#c7d2fe",
          padding: 5,
          cursor: "pointer",
        }}
      >
        Get Avg QPS
      </button>
    );
  };
  // const BtnCellRenderer = (rowData) => {
  //   const [inputs, setInputs] = useState(rowData.data.inappRtbCap);
  //   const handleChangesetInputs = (event) => {
  //     setInputs(event.target.value);
  //   };

  //   const GetAvgQPSFunc = (campaignId, seatId) => {
  //     console.log(campaignId);
  //     console.log(seatId);
  //     GetAvgQPS(campaignId, seatId);
  //   };
  //   return (
  //     <div style={{}}>
  //       <a style={{}} onClick={() => {}}>
  //         <button
  //           onClick={() => {
  //             GetAvgQPSFunc(rowData.data.campaignId, rowData.data.seatId);
  //           }}
  //         >
  //           aaa
  //         </button>
  //       </a>
  //     </div>
  //   );
  // };
  const [changes, setChanges] = useState([]);
  const [Loading, setLoading] = useState(true);

  // Function to handle cell value changes
  const onCellValueChanged = (params) => {
    const { data } = params;
    setChanges((prevChanges) => ({ ...prevChanges, [data.id]: data }));
  };

  const BtnCellRendererQPS = (rowData) => {
    const [inputs, setInputs] = useState(rowData.data.inappRtbCap);
    const handleChangesetInputs = (event, id) => {
      const updatedValue = event.target.value;
      setInputs(updatedValue); // Update the local state for the input field

      // Update the global changes state with the new value for this specific row
      setChanges((prevChanges) => ({
        ...prevChanges,
        [rowData.data.campaignId]: {
          ...prevChanges[rowData.data.campaignId],
          // id: rowData.data.id,
          // env: rowData.data.environment,
          // advertiserId: rowData.data.advertiserId,
          newValue: updatedValue, // Assuming 'inappRtbCap' is the field you want to update
          campaignId: rowData.data.campaignId,
          seatId: rowData.data.seatId,
        },
      }));
    };

    return (
      <div
        style={{
          backgroundColor: inputs === rowData.data.inappRtbCap ? "" : "#bbf7d0",
        }}
      >
        <a
          style={{
            borderWidth: 0,
            color: "green",
            cursor: "pointer",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            handleButtonClick(
              rowData.data.advertiserId,
              rowData.data.campaignId,
              rowData.data.environment,
              rowData.data.id,
              inputs,
              rowData.data.seatId
            );
          }}
        >
          <input
            type="text"
            value={inputs}
            onChange={(event) => handleChangesetInputs(event, rowData.data.id)} // Pass the row ID as well
          ></input>
        </a>
      </div>
    );
  };
  console.log(changes);
  const updateRowData = (node, value) => {
    const newData = { ...node.data, AvgQPS: value }; // Assuming 'newValueColumn' is the field in your data model where you want to display the '1'
    node.setData(newData);
  };
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Seat Name",
      flex: width > 766 ? 1 : null,
      field: "seatName",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Campaign id",
      flex: width > 766 ? 1 : null,
      field: "campaignId",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Campaign name",
      flex: width > 766 ? 1 : null,
      field: "campaignName",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Fill rate",
      flex: width > 766 ? 1 : null,
      field: "fillRateOp",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "QPS",
      flex: width > 766 ? 1 : null,
      field: "inappRtbCap",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      cellRenderer: BtnCellRendererQPS,
      // cellRendererParams: {
      //   clicked: function (field) {
      //     alert(`${field} was clicked`);
      //   },
      // },
    },
    {
      headerName: "Avg QPS",
      flex: width > 766 ? 1 : null,
      field: "AvgQPS",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      // cellRenderer: BtnCellRenderer,
      // cellRendererParams: {
      //   clicked: function (field) {
      //     alert(`${field} was clicked`);
      //   },
      // },
    },
    {
      headerName: "",
      flex: width > 766 ? 1 : null,
      field: "inappRtbCap",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        updateData: updateRowData,
      },
      // cellRendererParams: {
      //   clicked: function (field) {
      //     alert(`${field} was clicked`);
      //   },
      // },
    },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === SendDataToFirstTable1.length
        ? "bottom-row"
        : "";
    },
  };

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const containerStyle = useMemo(
    () => ({ width: "100%", height: screenHeight - 130 }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);
  const frameworkComponents = {
    actionsCellRenderer: ActionsCellRenderer,
  };

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const UpdateRtbItems = async (event) => {
    setLoading(false);
    const sss = [changes];
    const changesArray = Object.entries(changes).map((entry) => entry[1]);
    console.log(changes);
    console.log(sss);
    console.log(changesArray);
    //setLoading1(false);
    try {
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateRtbItemsMngm`,
        changesArray,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      //console.log(SendDataToFirstTable);
      //setLoading1(true);
      setLoading(true);
    } catch (error) {
      console.log("error in UpdateRtbItems");
    }
  };

  const GetAvgQPS = async (campaignId, seatId) => {
    setLoading(false);
    try {
      const response = await axios.get(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/GetAvgQps?campaignId=${campaignId}&seatId=${seatId}&env=mobile_app`,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      setvvv(response.data);
      console.log(SendDataToFirstTable1);

      //console.log(SendDataToFirstTable1);
      //setLoading1(true);
      setLoading(true);
      return response.data;
    } catch (error) {
      console.log("error in GetAvgQPS");
    }
  };
  return (
    <div style={{ paddingBottom: 30 }}>
      <div style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <span style={{ color: "#1a1523", fontSize: 18 }}>
            Source Management
          </span>
          <AgGridReact
            cellClassRules={ragCellClassRules}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={SendDataToFirstTable1} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection="multiple" // Options - allows click selection of rows
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            onGridReady={onGridReady}
            gridOptions={gridOptions}
            suppressScrollOnNewData={true}
            getRowHeight={getRowHeight}
            //domLayout="autoHeight"
            pagination={true}
            paginationPageSize={100}
            frameworkComponents={{
              btnCellRenderer: BtnCellRenderer,
              frameworkComponents,
            }}
          />
          <button
            onClick={UpdateRtbItems}
            style={{
              borderWidth: 0,
              borderRadius: 5,
              backgroundColor: "#c7d2fe",
              padding: 8,
              cursor: "pointer",
            }}
          >
            Update changed item's
          </button>
        </div>{" "}
      </div>{" "}
      <style>
        {`
                        .ag-theme-alpine .ag-root-wrapper {
                          border: none;
                        }
                      `}
        {`
                        .my-header-class {
                          background-color: white;
                        }
                      `}
        {`
                 .ag-header-cell {
                  background-color: white;
              }`}
      </style>
    </div>
  );
}

const ActionsCellRenderer = (props) => {
  const handleButtonClick = () => {
    // Add your button click logic here
    console.log(`Button clicked for row with ID: ${props.data.id}`);
  };

  return <button onClick={handleButtonClick}>Click Me</button>;
};
